<template>
        <div class="manageCars">
            <topNav :title="title"></topNav>
            
            <div class="btns" v-show="carList && carList.length<5">
                <van-button type="info" @click="addCar">前往新增车辆</van-button>
            </div>
            
            <section class="list list_mycars">
              <ul v-show="carList && carList.length">
                <li class="car" v-for="(item,index) in carList" :key="item.index">
                    <div class="carnum">{{item.vehicleno?item.vehicleno.slice(0,2): ''}}<b></b>{{item.vehicleno?item.vehicleno.slice(2): ''}}</div>
                    <div class="btn" @click.stop="deleteCar(item, index)">解除绑定</div>
                </li>
              </ul>
              <p class="emptyTip" v-show="!carList.length">暂无车辆</p>
            </section>
        </div>
</template>
<script>
    
        import Vue from 'vue'
        import topNav from "../topnav/topnav";
        import { Field,Cell,CellGroup,Button,Toast } from 'vant';
        import {DETAIL as API} from "@/assets/api";
        
        export default {
            name: 'manageCars',
            components:{
                // commonInput
                topNav,
                Field,
                [Cell.name]:Cell,
                [CellGroup.name]:CellGroup,
                Button,
                Toast
            },
            data() {
                return {
                    title:"车辆解绑"
                }
            },
            computed: {
              carList(){
                let list = Array.isArray(this.$store.state.cars) ? this.$store.state.cars : []
                return list
              }
            },
            created(){
              this.getCarList()
            },
            methods:{
              getCarList(){
                let req = {}
                let phonenumber = this.$store.state.phonenumber
                if(phonenumber){
                  req.phonenumber = phonenumber
                }else{
                  let originalId = sessionStorage.getItem("originalId")
                  if(originalId){
                    req.originalId = originalId
                  }
                }
                if(!req.phonenumber && !req.originalId){
                  this.$toast('暂无用户信息')
                  return
                }
                this.$http({
                    method: 'post',
                    url: API.GET_CARLIST,
                    data: this.qs.stringify(req),
                    success: function(data){
                      if(data.code == 0){
                        let cars = data.data[0].cars ? data.data[0].cars : []
                        this.$store.commit('getBindCars', cars)
                      }else{
                          this.$toast({
                              duration: 1200,
                              message: data.msg
                          });
                      }
                    }.bind(this),
                    error: function(error){
                        console.log(error)
                    }
                })
                
              },
              deleteCar(item, index){
                let browserType = this.$store.state.browserType;
                if(browserType !== 'wx' && browserType !== 'al') {Toast('请用微信或者支付宝打开!');return}
                let phonenumber = this.$store.state.phonenumber;

                let req = {
                    browserType: browserType,
                    phonenumber: phonenumber,
                    vehicleno: item.vehicleno,
                }
                this.$dialog.confirm({
                  message: '确认解除绑定该车辆'
                }).then(() => {
                  
                  this.isLoading = true;

                  this.$http({
                      method: 'post',
                      url: API.UNBIND_CAR,
                      data: this.qs.stringify(req),
                      success: function(data){
                        if(data.code == 0){
                            // this.carList.splice(index, 1)
                            this.$store.commit('deleteCar', index)
                            this.$toast({duration:1000,message:'解绑成功!'});
                        }else{
                            this.$toast({
                                duration: 1200,
                                message: data.msg
                            });
                        }
                      }.bind(this),
                      error: function(error){
                          console.log(error)
                      }
                  })
                })
                
              },
              addCar(){
                if(this.$store.state.cars && this.$store.state.cars.length == 5)  {Toast('车辆绑定数量已达到最大!');return}
                this.$router.push({name: 'bindCar'})
              }
            },
            watch:{
            }
    
    
        }
    </script>
<style lang="less" scoped>
  #topnav{
    margin-bottom: 20px;
  }

  .list_mycars{
    /* margin-bottom: 20px; */
    .car{
      position: relative;
      height: 80px;
      width: 92%;
      margin: 10px auto;
      background: url('../../../static/images/option_bg.png') center no-repeat;
      background-size: 100%;
      border-radius: 10px;
      .carnum{
        font-size: 24px;
        text-align: center;
        line-height: 80px;
        color: #fff;
        font-weight: 400;
        b{
          display: inline-block;
          width: 8px;
          height: 8px;
          border-radius: 8px;
          line-height: 90px;
          background: #fff;
          margin: 0 7px;
          margin-bottom: 4px;
        }
      }
      .btn{
        height: 23px;
        padding: 0 10px;
        position: absolute;
        top: 10px;
        right: 10px;
        color: #fff;
        font-size: 10px;
        text-align: center;
        line-height: 23px;
        background-color: hsla(0,0%,100%,.2);
        border-radius: 11px;
      }
    }
    .emptyTip{
      font-size: 16px;
      text-align: center;
      line-height: 60px;
    }
  }
  .btns{
    padding: 0 15px;
    .van-button{
      border-radius: 3px;
      outline: none;
      border: none;
      width: 100%;
      // height: 100%;
      background-color: #07c160;
      color: #fff;
    }
  }
</style>
    
    


// WEBPACK FOOTER //
// src/components/my/manageCars.vue